export default __webpack_public_path__ + "static/media/convert_arrow_black.28866f89.svg";